import React from 'react';
import i18n from '@i18n';
import { HomepageHierarchy } from '@/nikeone/components/PrematchSection';
import BoxOptionsContext, { HOMEPAGE } from '@/nikeone/context/BoxOptionsContext';
import useBoxStore from '@/nikeone/hook/useBoxStore';
import StyledBox from '@/ui/styledBox/StyledBox';
import { fireGAEvent } from '@/analytics';
import { CURRENT_PAGE } from 'nike-ui/src/common/routing';
import { NIKE1 } from '@/routing/routes';
import { navigate } from '@/routing';

function SuperOfferPage() {
    useBoxStore('homepage', HOMEPAGE, ['superoffer']);
    const styles = { paddingTop: '16px' };

    return (
        <>
            <StyledBox style={styles}>
                <BoxOptionsContext.Provider value={HOMEPAGE}>
                    <HomepageHierarchy boxStore="homepage" boxId="superoffer" showHeader />
                </BoxOptionsContext.Provider>
            </StyledBox>
            <GoToNikeOneSuperkurzy />
        </>
    );
}

function GoToNikeOneSuperkurzy() {
    function handleClick() {
        fireGAEvent(CURRENT_PAGE, 'Zobrazit celu ponuku', 'Superkurzy');
        navigate(NIKE1, { sportSlugPart: 'superkurzy' });
    }
    return (
        <div className="light-button full-width centered" onClick={handleClick}>
            {i18n('show.whole.offfer')}
        </div>
    );
}

export default SuperOfferPage;
